import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { googleSignUp } from "../../redux/slices/authSlice";
import { AuthStatus } from "../../types/auth";
import { useNavigate } from "react-router-dom";
import { telemetryService } from "../../telemetry/TelemetryService";
import { TelemetryEvents } from "../../telemetry/telemetryEvents";

const SocialLoginButtons: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate()
  const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";
  const { status } = useAppSelector((state) => state.auth)


  const handleSuccess = async (res: any) => {
   await dispatch(googleSignUp((res as { credential: string }).credential));
   window.location.href = '/interview-setup'
  };

  const handleFailure = (err: any) => {
  
  };

    useEffect(() => {
      if (status === "succeeded" ) {
        window.location.href = '/interview-setup'
      }
    }, [status, navigate])
  


  return (
    <div className="pt-2">
      <p className="text-center text-sm text-gray-400 mb-4">OR Login With</p>
      <div className="flex justify-center items-center space-x-4">
 
          <GoogleSignInButton
            clientId={clientId}
            onSignInSuccess={handleSuccess}
            onSignInFailure={handleFailure}
          />
      </div>
    </div>
  );
};

declare global {
  interface Window {
    google: any;
  }
}

const GoogleSignInButton: React.FC<{
  onSignInSuccess: (response: any) => void;
  clientId: string;
  onSignInFailure: (response: any) => void;
}> = ({ onSignInSuccess, clientId, onSignInFailure }) => {
  const { status } = useAppSelector((state) => state.auth);
  const [fallback, setFallback] = useState(false);

  const handleCredentialResponse = (response: { credential: any }) => {
    if (response.credential) {
      onSignInSuccess(response);
    } else {
      onSignInFailure(response);
    }
  };

  useEffect(() => {
    if (clientId && window.google) {
      try {
        window.google.accounts.id.initialize({
          client_id: clientId,
          callback: handleCredentialResponse,
          ux_mode: "popup",
          cancel_on_tap_outside: true,
          prompt_parent_id: "google-signin-button",
        });

        window.google.accounts.id.renderButton(
          document.getElementById("google-signin-button"),
          { theme: "outline", size: "large" }
        );

        window.google.accounts.id.prompt((notification: any) => {
          if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
            // Fallback to custom button if prompt isn't shown
            // setFallback(true);
          }
        });
        telemetryService.trackEvent(TelemetryEvents.GOOLGLE_SIGNIN_POPUP);
      } catch (err) {
        setFallback(true);
      }
    } else {
      setFallback(true);
    }
  }, [clientId]);

  const handleManualSignIn = () => {
    telemetryService.trackEvent(TelemetryEvents.GOOLGLE_MANUAL_SIGNIN_BUTTON);
    if (window.google && window.google.accounts) {
      telemetryService.trackEvent(TelemetryEvents.GOOLGLE_MANUAL_SIGNIN_POPUP);
      window.google.accounts.id.prompt(); // Opens the popup manually
    }
  };

  return (
    <div className="relative inline-block">
      { <div id="google-signin-button" />}

      {fallback &&(
        <button
          onClick={handleManualSignIn}
          className="bg-white border font-semibold border-gray-300 rounded-md px-4 py-2 text-sm text-gray-700 flex items-center space-x-2 hover:shadow-md"
        >
          <img
            src="https://developers.google.com/identity/images/g-logo.png"
            alt="Google logo"
            className="w-5 h-5"
          />
          <span>Sign in with Google</span>
        </button>
      )}

      {status === AuthStatus.LOADING && (
        <div className="absolute inset-0 opacity-50 cursor-not-allowed z-10 bg-white" />
      )}
    </div>
  );
};
export default SocialLoginButtons;
